module.exports = __webpack_public_path__ + "img/03.34e4256e.jpg";